import React from "react";
import CountUp from "react-countup";

const PureCounter = ({
  start = 0,
  end = 100,
  duration = 5,
  className = "",
  suffix = "",
  prefix = "",
  decimals = 0,
  separator = ",",
}) => {
  return (
    <span className={className}>
      <CountUp
        start={start}
        end={end}
        duration={duration}
        separator={separator}
        decimals={decimals}
        suffix={suffix}
        prefix={prefix}
      />
    </span>
  );
};

export default PureCounter;
